import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6434c389"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "HintHolder"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Hint" }, "Родительское направление", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 2,
  class: "HintHolder"
}
const _hoisted_6 = { class: "MainText" }
const _hoisted_7 = {
  key: 0,
  class: "Hint"
}
const _hoisted_8 = {
  key: 5,
  class: "flex justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!

  return (_ctx.column.key === 'direction')
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        class: "text-blue-500",
        to: `/tms/directions/${_ctx.row.id}`,
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.row.fromCity ? _ctx.row.fromCity.name : '...') + " - " + _toDisplayString(_ctx.row.whereCity ? _ctx.row.whereCity.name : '...'), 1)
        ]),
        _: 1
      }, 8, ["to"]))
    : (_ctx.column.key === 'isParent' && _ctx.row.directionType && _ctx.row.directionType.id === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : (_ctx.column.key === 'zone' && _ctx.row.zone)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.row.zone.number), 1),
            (_ctx.row.zone.description)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.row.zone.description), 1))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.column.key === 'isNearbyCities')
          ? (_openBlock(), _createElementBlock("i", {
              key: 3,
              class: _normalizeClass(_ctx.getCheckOrTimesIcon(_ctx.row.isNearbyCities))
            }, null, 2))
          : (_ctx.column.key === 'status')
            ? (_openBlock(), _createBlock(_component_cheap, {
                key: 4,
                class: _normalizeClass(["small", _ctx.row.isActive ? 'green' : 'red'])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.row.isActive ? 'Активно' : 'Не активно'), 1)
                ]),
                _: 1
              }, 8, ["class"]))
            : (_ctx.column.key === 'internalDirectionsCount')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.row[_ctx.column.key]), 1))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                  _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key]), 1)
                ], 64))
}